<template>
  <div>
    <div class="installation-of-the-month-attachments-modal-window" :class="{'open': selected_submission !== null}" @click="selected_submission = null, selected_image_index = 0"
         v-if="selected_submission !== null">
      <div class="modal-window-inner" @click.stop>
        <div class="modal-close" @click.stop="selected_submission = null, selected_image_index = 0">
          <i class="fal fa-times"></i>
        </div>
        <div class="modal-content">
          <div class="selected-image">
            <img :src="`${$aws_bucket_url}${selected_submission.attachments[selected_image_index].file_url}`">
            <a class="download-button" @click.prevent="downloadAttachment(selected_submission.attachments[selected_image_index].id)">
              <i class="fal fa-download"></i>
            </a>
          </div>
          <div v-if="selected_submission.winner" class="title-bar">
            {{ selected_submission.friendly_month_submitted_at }}'s Winner - {{ selected_submission.company_name }}
          </div>
          <div class="installation-of-the-month-attachments">
            <div v-for="(attachment,  index) in selected_submission.attachments" class="attachment">
              <a @click.prevent="selected_image_index = index" :style="attachmentThumbUrl(attachment)" class="image">
                <span class="view-btn"><i class="fal fa-search"></i></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="installation-of-the-month-previous-winners-calendar">
      <div class="years">
        <div class="main-title">
          <h1>Installation Showcase</h1>
        </div>
        <div v-for="(years, year) in previous_winners" class="year-box">
          <strong>{{ year }}</strong>
          <div class="months">
            <template v-for="(winners, month) in years">
              <div class="month-box" v-for="winner in winners" :class="`month-${month}`">
                <div class="month-box-inner">
                  <strong>{{ months[parseInt(month) - 1][month] }}</strong>
                  <div class="image" :style="attachmentThumbUrl(winner.attachments[0])" @click="selected_submission = winner, createActivityLog()"></div>
                </div>
              </div>
            </template>
            <div class="month-box month-submit" v-if="todaysYear == year">
              <div class="month-box-inner">
                <strong>Submit</strong>
                <a class="this-month" href="/installation-of-the-month">
                  Submit your entries!
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    props: [
        'past_winners',
    ],
    data() {
        return {
          previous_winners: [],
          months: [
            {'01': 'January'},
            {'02': 'February'},
            {'03': 'March'},
            {'04': 'April'},
            {'05': 'May'},
            {'06': 'June'},
            {'07': 'July'},
            {'08': 'August'},
            {'09': 'September'},
            {'10': 'October'},
            {'11': 'November'},
            {'12': 'December'},
          ],
          selected_submission: null,
          selected_image_index: 0,
        };
    },
    computed: {
      todaysMonthNumber() {
        const d = new Date();
        let month = d.getMonth()+1;
        if (month < 10) {
          return "0"+month;
        } else {
          return month.toString();
        }
      },
      todaysYear() {
        const d = new Date();
        return d.getFullYear();
      }
    },
    mounted() {
      this.loadPreviousWinners();
    },
    methods: {
      async loadPreviousWinners() {
        axios.post('/installation-of-the-month/loadPreviousWinnersForCurrentYear').then((response) => {
          this.previous_winners = response.data;
        });
      },
      attachmentUrl(attachment) {
        return {'backgroundImage': `url('${this.$aws_bucket_url}${attachment.file_url}')`};
      },
      attachmentThumbUrl(attachment) {
        if (attachment.thumbExists) {
          return {'backgroundImage': `url('${this.$aws_bucket_url}${attachment.thumbnail_url}')`};
        }
        return this.attachmentUrl(attachment);
      },
      downloadAttachment(attachment_id) {
        axios.post('/installation-of-the-month/download-attachment', {
          attachment_id: attachment_id,
        }).then((response) => {
          window.location.href = response.data;
        });
      },
      getWinnersForMonth(years, month) {
        return years[Object.keys(month)];
      },
      createActivityLog() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 8,
          'description': `Installation Showcase winner for ${this.selected_submission.friendly_month_submitted_at} (${this.selected_submission.user.company.name}) viewed`,
        });
      },
    },
}

</script>

<style scoped>
.month-01 {
  order: 1;
}
.month-02 {
  order: 2;
}
.month-03 {
  order: 3;
}
.month-04 {
  order: 4;
}
.month-05 {
  order: 5;
}
.month-06 {
  order: 6;
}
.month-07 {
  order: 7;
}
.month-08 {
  order: 8;
}
.month-09 {
  order: 9;
}
.month-10 {
  order: 10;
}
.month-11 {
  order: 11;
}
.month-12 {
  order: 12;
}
.month-submit {
  order: 13;
}
</style>
